import * as React from 'react';

import { Button } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import * as state from '../../_state/purchaseOrderDetails.state';
import { customerPortalRoutes } from '../../routes';
import { purchaseOrderDocuments } from '../_shared/availableDocuments';
import {
  DownloadDocumentsButton,
  PrintDocumentsButton,
} from '../_shared/FetchDocuments';

import { useModuleLocation } from '~/shared/hooks/useModuleLocation';

export const PurchaseOrderHeaderActions = () => {
  const purchaseOrderId = useAtomValue(state.$purchaseOrderId);
  const [, navigate] = useModuleLocation();

  const handleOpenCounterpartySOModal = () =>
    navigate(customerPortalRoutes.purchaseOrderCounterpartySO, {
      params: {
        purchaseOrderId,
      },
    });

  return (
    <div className="@PurchaseOrderHeaderActions flex gap-2">
      <PrintDocumentsButton
        originKey="purchase-order-header"
        documents={purchaseOrderDocuments}
        ids={[purchaseOrderId]}
        showLabel={false}
      />
      <DownloadDocumentsButton
        originKey="purchase-order-header"
        compressedFileName={`purchase-order-${purchaseOrderId}`}
        documents={purchaseOrderDocuments}
        ids={[purchaseOrderId]}
        showLabel={false}
      />
      <Button
        variant="outline"
        color="neutral"
        className="border-neutral/20"
        onClick={handleOpenCounterpartySOModal}
      >
        View Counterparty SO
      </Button>
    </div>
  );
};
